import { isB2C } from '@/core/settings/utils';

export const GTM_CLICK_BRAND = (brandName: string) => ({
  amp_event_name: 'Click homepage brand block',
  block_clicked: brandName,
  event: 'interaction_click homepage brand block',
  event_trigger: isB2C() ? 'homepage b2c' : 'homepage b2b',
  page_type: 'home',
});
